export function activeMention(value, caret, mentions) {
  const match = value.slice(0, caret).match(/(?:^|\s)@([^@\n]*)$/);
  if (!match) return null;
  const start = caret - match[1].length - 1;
  if (mentions.some(mention => mention.start === start)) return null;
  return { start, end: caret, term: match[1] };
}

export function updateMentionRanges(previous, next, mentions) {
  let start = 0;
  while (start < previous.length && start < next.length && previous[start] === next[start]) start++;
  let end = previous.length;
  let nextEnd = next.length;
  while (end > start && nextEnd > start && previous[end - 1] === next[nextEnd - 1]) { end--; nextEnd--; }
  const delta = next.length - previous.length;
  return mentions.flatMap(mention => {
    if (mention.start + mention.length <= start) return [mention];
    if (mention.start >= end) return [{ ...mention, start: mention.start + delta }];
    return [];
  });
}

export function readDiscussionMentions(message, json) {
  try {
    let end = 0;
    return JSON.parse(json || "[]").map(item => ({
      userId: item.UserId ?? item.userId, start: item.Start ?? item.start, length: item.Length ?? item.length,
    })).sort((a, b) => a.start - b.start).filter(item => {
      const valid = Number.isInteger(item.start) && Number.isInteger(item.length) && item.start >= end && item.length > 0 && item.start + item.length <= message.length;
      if (valid) end = item.start + item.length;
      return valid;
    });
  } catch { return []; }
}
